import { useT } from '@repo/ui/hooks'
import { Wand2 } from 'lucide-react'
import { Link } from 'react-router-dom'

import { buildSearchParam, SearchParamsViewNames } from '@/routes'

export function Empty() {
  const { t } = useT({ keyPrefix: 'admin.insights.list' })

  return (
    <div className="h-full w-full flex items-center justify-center">
      <div className="text-center space-y-4">
        <p className="text-xl font-medium">{t('noWidgets.title')}</p>

        <div className="flex flex-col text-sm text-primary-500 gap-2">
          <div>
            <Link
              to={buildSearchParam('view', SearchParamsViewNames.INSIGHTS_CHAT)}
              className="inline-flex items-center gap-2 hover:bg-primary-100 hover:text-primary-900 dark:hover:bg-primary-800 dark:hover:text-primary-50 relative rounded-sm px-2 py-1.5 text-sm outline-none transition-colors"
            >
              <Wand2 className="size-4" />
              {t('noWidgets.buildInsights')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
